import { db } from "../../../fire";

const MAX_VERSIONS = 4;

// interface Props {
//   main: boolean;
//   referente: string;
//   service: string;
//   responsavel: string;
//   data: FormContentInterface;
// }

export async function saveContentData({
  referente,
  service,
  responsavel,
  data,
  main,
}) {
  try {
    const oldVersionsSnap = await db
      .collection("conteudo")
      .where("referente", "==", referente)
      .get();

    // Ordena os documentos por versão
    const oldVersionsSorted = oldVersionsSnap.docs.sort((a, b) => {
      const versionA = a.data().version;
      const versionB = b.data().version;

      return versionA - versionB;
    });

    const oldVersions = oldVersionsSorted.map((oldVersion) =>
      oldVersion.data()
    );

    let newVersion = 0;

    if (oldVersions.length > 0) {
      const actualVersion = oldVersions[oldVersions.length - 1].version;

      newVersion = actualVersion + 1;

      let docsCounter = oldVersions.length;

      let counter = 0;
      while (docsCounter > MAX_VERSIONS - 1) {
        await db
          .doc(
            `conteudo/${oldVersions[counter].referente}_${oldVersions[counter].version}`
          )
          .delete();

        counter++;
        docsCounter--;
      }
    }

    ["subject", "instructor", "reviewer"].forEach((type) => {
      const index = data.findIndex((content) => content.type === type);

      data.splice(index, 1);
    });

    const topicContentIndex = data.findIndex(
      (content) => content.type === "topic"
    );

    for (const key in data[topicContentIndex].itens) {
      delete data[topicContentIndex].itens[key].itens[0].itens[0].htmls;
    }

    await db.doc(`conteudo/${referente}_${newVersion}`).set({
      main: main || false,
      version: newVersion,
      service,
      responsavel,
      referente,
      data,
    });

    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export async function getLastVersion(referente) {
  const allVersions = await db
    .collection("conteudo")
    .where("referente", "==", referente)
    .get();

  const lastVersion = allVersions.docs.reduce(
    (lastVersion, actualVersion) => {
      const versionData = actualVersion.data();

      if (versionData.version > lastVersion?.version) {
        return versionData;
      }

      return lastVersion;
    },
    { version: -1 }
  );

  if (lastVersion.version !== -1) return lastVersion;
}
